import React, { Component } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import "date-fns";
import moment from 'moment';
import { EditorState, convertToRaw } from 'draft-js';
import createSingleLinePlugin from 'draft-js-single-line-plugin';
import Editor from 'draft-js-plugins-editor';
import createMentionPlugin, { defaultSuggestionsFilter } from 'draft-js-mention-plugin';
import { editorStateToJSON } from "megadraft-denistsuman/lib/utils";
import 'draft-js-mention-plugin/lib/plugin.css';
import { Grid } from "@material-ui/core";
var mentions = []

class AddComment extends Component {
    constructor(props) {
        super(props);
        this.mentionPlugin = createMentionPlugin({
            mentions,
            entityMutability: 'IMMUTABLE',
            mentionPrefix: '@',
            supportWhitespace: true
        });

        this.singleLinePlugin = createSingleLinePlugin({
            stripEntities: false
        });
        this.state = {
            editorState: EditorState.createEmpty(),
            suggestions: mentions,
        };
    }
    componentWillMount() {
        if (this.props.settingReducer.usersListArray &&
            this.props.settingReducer.usersListArray.data) {
            let users = [];
            this.props.settingReducer.usersListArray.data.map((user) => {
                users.push({
                    id: user.id,
                    name: user.name,
                });
            });
            mentions = users;
        }
    }

    onChange = (editorState) => {
        this.setState({ editorState });
        const content = editorState.getCurrentContent();
        const textvalue = content.getPlainText('\u0001');
        const raw = JSON.parse(editorStateToJSON(editorState));
        this.props.getdata({ textvalue: textvalue, raw: raw })
    };

    onSearchChange = ({ value }) => {
        this.setState({
            suggestions: defaultSuggestionsFilter(value, mentions),
        });
    };

    focus = () => {
        this.editor.focus();
    };
    componentDidUpdate = (prevProps) => {
        if (prevProps.commentvalue !== this.props.commentvalue) {
            if (this.props.commentvalue === "") {
                let editorState = EditorState.createEmpty();
                this.setState({ editorState: editorState })
            }
        }
    }
    findWithAttr = (array, attr, value) => {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }
    toCamelCase = (s) => {
        return s.replace(/([-_][a-z])/ig, ($1) => {
            return $1.toUpperCase()
                .replace('-', '')
                .replace('_', '');
        });
    };
    onAddMention = (mention) => {
        let that = this;
        setTimeout(() => {
            that.setState({ editorState: EditorState.moveFocusToEnd(that.state.editorState) })
        }, 10);
    }
    handleClose = () => {
        let editorState = EditorState.createEmpty();
        this.setState({ editorState: editorState })
        this.props.handleClose();
    }
    render() {
        const { MentionSuggestions } = this.mentionPlugin;
        const plugins = [this.mentionPlugin, this.singleLinePlugin];
        return (
            <>
                <Grid item xs={12} style={{ "minWidth": "200px","maxWidth":"85%" }}
                    className={"crm-editor-mention"}
                    onClick={this.focus}>
                    <label style={{ fontSize: '12px' }} >Text</label>
                    <Editor
                        editorState={this.state.editorState}
                        onChange={this.onChange}
                        plugins={plugins}
                        blockRenderMap={createSingleLinePlugin.blockRenderMap}
                        ref={(element) => { this.editor = element; }}
                        spellCheck
                        placeholder="Add Comment"
                    />
                    <MentionSuggestions
                        onSearchChange={this.onSearchChange}
                        suggestions={this.state.suggestions}
                        onAddMention={this.onAddMention}
                    />
                </Grid>
            </>
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
});
export default connect(mapStateToProps)(AddComment);
